<div (click)="showFicheEntreprise()" class="feEntrepriseItem">
    <fe-icon *ngIf="webToLead && webToLeadCompanies.includes(companyId)" [iconType]="IconType.web_to_lead"
             (click)="exportEnterpriseWebToLead($event)"/>
    <span>{{entreprise.name}}</span>
    <mat-icon>chevron_right</mat-icon>
</div>
